import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Link
} from '@mui/material';

const LicenseModal = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Open Source Licenses</DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2" component="div">
        <Box component="ul" sx={{ pl: 3 }}>
          <li>
            <Link href="https://www.npmjs.com/package/react" target="_blank" rel="noopener noreferrer">
              React
            </Link>
          </li>
          <li>
            <Link href="https://www.npmjs.com/package/@mui/material" target="_blank" rel="noopener noreferrer">
              Material UI
            </Link>
          </li>
          <li>
            <Link href="https://www.npmjs.com/package/@dnd-kit/core" target="_blank" rel="noopener noreferrer">
              DnD Kit
            </Link>
          </li>
          <li>
            <Link href="https://www.npmjs.com/package/jspdf" target="_blank" rel="noopener noreferrer">
              jsPDF
            </Link>
          </li>
          <li>
            <Link href="https://www.npmjs.com/package/pdf-lib" target="_blank" rel="noopener noreferrer">
              PDF-LIB
            </Link>
          </li>
          <li>
            <Link href="https://www.npmjs.com/package/uuid" target="_blank" rel="noopener noreferrer">
              uuid
            </Link>
          </li>
        </Box>
        <Typography variant="caption" color="text.secondary">
          All libraries listed above are licensed under the MIT License.
        </Typography>
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default LicenseModal;
